// import

import {isProd} from '@sitearcade/is-env';
import Head from 'next/head';
import {useState, useEffect} from 'react';

// vars

const gtmKey = process.env.GTM_KEY_WEB;

const envParams = isProd ? '' :
  '&gtm_auth=m0CdgsNUDF-7ZyV8DORHlg&gtm_preview=env-7&gtm_cookies_win=x';

const script = `
(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.defer=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl+'${envParams}';
f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${gtmKey}');
`;

// components

export function GoogleTagManager() {
  const [tag, setTag] = useState<JSX.Element | null>(null);

  useEffect(() => setTag(
    <script dangerouslySetInnerHTML={{__html: script}} />,
  ), []);

  return (
    <>
      <Head>
        <link href="https://www.googletagmanager.com" rel="preconnect" />
        {tag}
      </Head>

      <noscript>
        <iframe
          height="0"
          src={`https://www.googletagmanager.com/ns.html?id=${gtmKey}${envParams}`}
          style={{display: 'none', visibility: 'hidden'}}
          title="gtm"
          width="0"
        />
      </noscript>
    </>
  );
}
